<template>
  <div class="dataForm" >
    <el-form
      ref="dataForm"
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      label-width="100px"
      class="mb-20"
      :disabled="mode === 'approval'"
    >
      <div class="underlineForm">
        <div class="mb-20 fullWidth" v-if="mode !== 'approval' && !isEdit">
          <el-button @click="handleAddComand" type="primary">
            添加材料
          </el-button>
          <el-button @click="handleRemove">
            移除材料
          </el-button>
        </div>
        <el-table
          :data="ruleForm.details"
          border
          fit
          row-key="id"
          class="fullWidth"
          :summary-method="getSummaries"
          show-summary
          :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
          @selection-change="handleTableSelect"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column prop="amount" label="预购数量" width="140">
            <template #default="{ row }">
              <el-input v-model="row.amount" type="number" ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="materialNo" label="物料编号" show-overflow-tooltip min-width="100"/>
          <el-table-column prop="materialName" label="名称" show-overflow-tooltip/>
          <el-table-column prop="materialClass" label="物料类别" show-overflow-tooltip/>
          <el-table-column prop="materialUnit" label="物料单位" show-overflow-tooltip/>
          <el-table-column prop="materialStandard" label="封装规格" show-overflow-tooltip/>
          <el-table-column prop="max" label="最高价" show-overflow-tooltip min-width="120">
            <template #default="scope">
              <el-tooltip
                effect="dark"
                placement="top-start"
                v-if="scope.row.max"
              >
                <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.max?.updateTime}}</template>
                <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
              </el-tooltip>
              {{ maxMinCalc(scope.row, 'max') }}
            </template>
          </el-table-column>
          <el-table-column prop="min" label="最低价" show-overflow-tooltip min-width="120">
             <template #default="scope">
              <el-tooltip
                effect="dark"
                placement="top-start"
                v-if="scope.row.min"
              >
                <template #content> {{scope.row.min?.supplier?.name}}<br /> 最后修改时间：{{scope.row.min?.updateTime}}</template>
                <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
              </el-tooltip>
              {{ maxMinCalc(scope.row, 'min') }}
            </template>
          </el-table-column>

        </el-table>
      </div>
    </el-form>
     <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
    <el-dialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      title="物料列表"
      width="80%"
      :before-close="() => dialogVisible = false"
    >
      <MaterialDialog ref="MaterialDialog" :excludeIds="getexcludeIds()"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click="handleChoose"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
// import { getDetailById } from '@/apis/Dictionary'

import { ElMessage, ElForm, ElMessageBox } from 'element-plus'
import { createPurchaseInAdvance } from '@/apis/Purchase'
import { postUrl } from '@/apis/Dictionary'

import MaterialDialog from '@/views/purchasManage/materialInfo/MaterialDialog.vue'
import { useI18n } from 'vue-i18n'
import $number from 'number-precision'
import { cloneDeep } from 'lodash'
import { maxMinCalc } from '@/views/purchasManage/materialInfo/FieldTable'

export default defineComponent({
  components: {
    MaterialDialog
  },
  props: {
    isEdit: { type: Boolean, required: false },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    selectionBusiness: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: 'quotation' },
    selectcCustomerCompanyId: { type: [String, Number], required: false, default: '' },
    mode: { type: String, required: false, default: '' },
    marketingFee: { type: Boolean, required: false, default: false },
    fromFieldData: { type: Object, required: false },
    selectRows: { type: Array, required: false, default: () => [] }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const MaterialDialog = ref({})

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      submitLoading: false,
      ruleForm: {
        titleId: '',
        taxRate: 0,
        customerCompanyId: '' as any,
        customerNo: '',
        pictures: [] as any,
        mark: '',
        details: [] as any
      },
      rules: {
        customerNo: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        titleId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        taxRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: [],
        pictures: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      titleOption: [],
      companyOption: [],
      dialogVisible: false,
      selectMaterialDialog: [],
      taxRateList: [],
      excludeIds: [],
      maxMinCalc,
      isEdit: props.isEdit,

      handleAddComand() {
        dataMap.dialogVisible = true
      },
      getexcludeIds() {
        dataMap.excludeIds = dataMap.ruleForm.details.map((k: any) => {
          return k.materialId
        })
        return dataMap.excludeIds
      },
      handleTableSelect(selection: any) {
        dataMap.selectMaterialDialog = selection
      },
      handleChoose(array: any) {
        let tempArray = array && array.length ? array : (MaterialDialog.value as any).selectionArray
        tempArray = dataMap.ruleForm.details.concat(tempArray)
        dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
          return {
            ...item,
            materialId: item.materialId || item.id,
            materialNo: item.materialNo || item.no,
            materialName: item.materialName || item.name,
            amount: item.amount || 0
          }
        })
        dataMap.dialogVisible = false
      },
      handleRemove() {
        if (!dataMap.selectMaterialDialog.length) {
          return ElMessage.error('请选择需要移除的材料！')
        }
        dataMap.ruleForm.details = dataMap.ruleForm.details.filter((k: any) => {
          return !dataMap.selectMaterialDialog.find(j => j.id === k.id)
        })
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const { details } = dataMap.ruleForm
              const tempData = details.map((kk: any) => {
                return {
                  id: kk.id || '',
                  materialId: kk.materialId,
                  amount: kk.amount
                }
              })
              for (let i = 0; i < details.length; i++) {
                const item = details[i]
                if (item.amount === 0) {
                  ElMessageBox.confirm(
                    `是否确定${item.materialName}材料预购数量为0？`,
                    '提示',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      cancelButtonClass: 'el-button--danger'
                    }
                  ).then(() => {
                    dataMap.handleSubmitFun({ details: tempData })
                  })
                  return
                }
              }
              dataMap.handleSubmitFun({ details: tempData })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      async handleSubmitFun(tempData: any) {
        const formSate = !props.isEdit ? 'add' : 'edit'
        let result = null
        if (formSate === 'add') {
          result = await createPurchaseInAdvance(tempData)
        } else {
          result = await postUrl(props.api, tempData)
        }
        dataMap.submitLoading = false
        context.emit('update:visibel')
        context.emit('submit', result)
        ElMessage({
          message: !props.isEdit ? '创建成功！' : '编辑成功！',
          type: 'success',
          duration: 2000
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['amount'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            const sumNum = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`
            sums[index] = sumNum.toString()
          } else {
            sums[index] = ''
          }
        })
        return sums
      }
    })
    onMounted(() => {
      if (props.selectRows) {
        dataMap.ruleForm.details = cloneDeep(props.selectRows)
      }
      dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, MaterialDialog }
  }
})
</script>
